import { useTranslation } from 'react-i18next';
import { TimelineTrendChartDataDto, PlayerStatChartConfigDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import TimelineTrendChart from 'components/Charts/TimelineTrendChart/TimelineTrendChart';

const ReportTimelineTrendChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<TimelineTrendChartDataDto, PlayerStatChartConfigDto>) => {
  const { t } = useTranslation();

  return (
    <TimelineTrendChart
      label={t(chartConfig.playerStat)}
      trendPoints={chartData?.movingAverage ?? []}
      linePoints={chartData?.rollingAverage ?? []}
    />
  );
};

export default ReportTimelineTrendChart;
